module.exports = __webpack_public_path__ + "img/git-branch.b1c2561f.svg";